import { Navigate } from 'react-router-dom';
import { useAuth } from '../../auth/hooks/useAuth';
import { hasRoleAccess, ROLES } from '../../auth/roles';
import { BranchInitializationForm } from '../components/BranchInitializationForm';
import { LanguageToggle } from '../../locale/components/LanguageToggle';
import layoutStyles from '../../auth/components/AuthLayout.module.css';
import primitives from '../../../styles/primitives.module.css';
import bootstrapStyles from '../../auth/components/BootstrapForm.module.css';

export const BranchInitializationPage = ({
  user,
  token,
  t,
  locale,
  onLocaleChange,
  onComplete,
  branchesInitialized,
}) => {
  const { requiresPasswordRenewal, isChecking } = useAuth();

  if (isChecking) {
    return null;
  }

  if (requiresPasswordRenewal) {
    return <Navigate to="/renew-password" replace />;
  }

  if (branchesInitialized) {
    return <Navigate to="/" replace />;
  }

  const canManageBranches = hasRoleAccess(user?.role, ROLES.ADMIN);

  return (
    <div className={layoutStyles.shell}>
      <main className={layoutStyles.panel}>
        <header className={layoutStyles.header}>
          <div className={layoutStyles.intro}>
            <p className={primitives.eyebrow}>{t('appName')}</p>
            <h1>{t('accessTitle')}</h1>
            <p className={primitives.subtitle}>
              {canManageBranches ? t('branchInitPageSubtitle') : t('branchInitWaitingSubtitle')}
            </p>
          </div>
        </header>

        {canManageBranches ? (
          <BranchInitializationForm token={token} t={t} onComplete={onComplete} />
        ) : (
          <section className={bootstrapStyles.container}>
            <div className={bootstrapStyles.header}>
              <h2>{t('branchInitWaitingTitle')}</h2>
              <p>{t('branchInitWaitingMessage')}</p>
            </div>
          </section>
        )}

        <div className={layoutStyles.footer}>
          <LanguageToggle locale={locale} onChange={onLocaleChange} />
        </div>
      </main>
    </div>
  );
};
